import { render } from "./matching-list-interests-targets.vue?vue&type=template&id=cb4dc4fa&scoped=true&ts=true"
import script from "./matching-list-interests-targets.vue?vue&type=script&lang=ts"
export * from "./matching-list-interests-targets.vue?vue&type=script&lang=ts"

import "./matching-list-interests-targets.vue?vue&type=style&index=0&id=cb4dc4fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb4dc4fa"]])

export default __exports__